import { UserInfo } from '@numa-group/checkout-api/dist/schemas/user-info.schema';
import { AxiosInstance } from 'axios';

import { IAuthService } from '@src/features/auth/services/i-auth-service';
import { AmendmentRepositoryMock } from '@src/mocks/repositories/amendment.repository.mock';

import { AmendmentRepository } from './amendment.repository';
import { AmendmentRepositoryAxios } from './amendment.repository.axios';

export class AmendmentService {
  private constructor(private readonly amendmentRepository: AmendmentRepository) {}

  async getRoomUpgradeOffers(reservationId: string, config?: { user: Partial<UserInfo> }) {
    return this.amendmentRepository.getRoomUpgradeOffers(reservationId, config);
  }

  public static create(axiosInstance: AxiosInstance, authService: IAuthService): AmendmentService {
    const isMockEnabled = process.env.NEXT_PUBLIC_MOCKS_ACTIVE === 'true';

    const amendmentRepository = isMockEnabled
      ? new AmendmentRepositoryMock(axiosInstance, authService)
      : new AmendmentRepositoryAxios(axiosInstance, authService);

    return new AmendmentService(amendmentRepository);
  }
}
